import { checkAllFilesSize, checkFileExtensions } from '../../../modules/Taps/services/FileService';
import { getFileSize } from '../../../utils/format';

export async function validateFiles(inputFiles, options) {
  const {
    accept,
    files,
    allFilesMaxSizeMb,
    checkSingleFileSize,
    maxFileSizeMb,
    fileAvailableSizeMb,
  } = options;
  checkFileExtensions(inputFiles, accept);
  checkAllFilesSize(inputFiles, {
    files,
    allFilesMaxSizeMb,
    maxFileSizeMb,
    fileAvailableSizeMb,
    checkSingleFileSize,
  });
}
export function setFileSize(fileObject) {
  const sizeObject = getFileSize(fileObject.fileBlob.size);

  return {
    ...fileObject,
    size: fileObject.fileBlob.size,
    sizeToDisplay: sizeObject.label,
  };
}
